import { Box, Image, Text, Center } from '@chakra-ui/react';
import type { User } from '@halo/chat-sdk-react';
import EmptyShorts from './images/empty-shorts.png';

interface ShortsContentProps {
  user?: User | null;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ShortsContent = ({ user }: ShortsContentProps) => {
  const { t } = useTranslation();
  // console.log(user);
  return (
    <Box>
      <Center flexDir="column" gap="2">
        <Image w="165px" h="100px" src={EmptyShorts} alt="empty shorts" />
        <Text fontSize="sm">{t('profile.shortsTips')}</Text>
      </Center>
    </Box>
  );
};

const MemoizedShortsContent = memo(ShortsContent);
export { MemoizedShortsContent as ShortsContent };
